
import {ProfileForumTopicModel } from '../models/ProfileForumTopicModel.js';
import {ProfileForumTopicView } from '../views/ProfileForumTopicView.js';

export class ProfileForumTopicController {
    constructor() {

        this.model = new ProfileForumTopicModel();
        this.view = new ProfileForumTopicView();

        this.model.subscribe(state => this.view.render(state));
    }
}